import Tags from '@framework/ui/Organisms/Filters/FiltersPanel/Tags';
import { createFiltersFormatter } from '@framework/ui/Organisms/Filters/FiltersPanel/Tags/helpers';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import { allowedToRemoveFilters, filtersKeys } from './constants';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';
import { CURRENT_FACE_RANGE_PRESET } from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/constants';

const filtersFormatter = createFiltersFormatter({ currentFaceRangePreset: CURRENT_FACE_RANGE_PRESET });

const BondsSidebarTagsContainer = (props) => {
  const { dateFromMin } = useBondsFiltersContext();

  return (
    <Tags
      { ...props }
      filters={ getFiltersByKeysWithValues({ filtersState: props.filters, filtersKeys, dateFromMin }) }
      filtersFormatter={ filtersFormatter }
      allowedToRemoveFilters={ allowedToRemoveFilters }
      filterFormatterData={ props.filters.currentFaceRange }
    />
  );
};

export default BondsSidebarTagsContainer;
